import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {IQrefInfOtkaz as dictionaryInterface} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-infOtkaz',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefInfOtkazViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="id"
                         name="zapNomer"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="'zapNomer'"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.zapNomer }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          {{ item.zapNomer }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefInfOtkazViewComponent extends ViewDictionaryBase<dictionaryInterface> {
  getDictionary = this.dictSrv.getQrefInfOtkazList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
